import Vue from "vue";

import { store } from "../store/store";
// import utils from "../helpers/utils"

export default {
  token() {
    return store.state.WBToken || localStorage.getItem("WBToken");
  },
  isQuinyx() {
    return process.env.ALFA_ID === "quinyx";
  },
  get(url, params) {
    let urlString = url;
    const token = this.token();

    if (!this.isQuinyx() || (this.isQuinyx() && token)) {
      params.push({ key: "access_token", value: token });
    }

    for (let i = 0; i < params.length; i++) {
      i === 0 ? (urlString += "?") : (urlString += "&");

      urlString += `${params[i].key}=${params[i].value}`;
    }

    return new Promise((resolve, reject) => {
      Vue.http.get(urlString).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  post(url, params, data) {
    let urlString = url;
    const token = this.token();

    if (!this.isQuinyx() || (this.isQuinyx() && token)) {
      params.push({ key: "access_token", value: token });
    }

    for (let i = 0; i < params.length; i++) {
      i === 0 ? (urlString += "?") : (urlString += "&");

      urlString += `${params[i].key}=${params[i].value}`;
    }
    return new Promise((resolve, reject) => {
      Vue.http.post(urlString, data).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  put(url, params, data) {
    let urlString = url;
    const token = this.token();

    if (!this.isQuinyx() || (this.isQuinyx() && token)) {
      params.push({ key: "access_token", value: token });
    }

    for (let i = 0; i < params.length; i++) {
      i === 0 ? (urlString += "?") : (urlString += "&");

      urlString += `${params[i].key}=${params[i].value}`;
    }

    return new Promise((resolve, reject) => {
      Vue.http.put(urlString, data).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  delete(url, id, params) {
    let urlString = `${url}`;
    if (id) {
      urlString = `${url}/${id}`;
    }
    const token = this.token();

    if (!this.isQuinyx() || (this.isQuinyx() && token)) {
      urlString += "?access_token=" + token;
    }

    if (params) {
      for (let i = 0; i < params.length; i++) {
        const delimeter = urlString.includes("?") ? "&" : "?";
        urlString += `${delimeter}${params[i].key}=${params[i].value}`;
      }
    }

    return new Promise((resolve, reject) => {
      Vue.http.delete(urlString).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },

  formatDate(dates) {
    if (dates && dates !== "-") {
      const date = new Date(dates);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      const strTime = hours + ":" + minutes + " " + ampm;
      return (
        date.getDate() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear() +
        " " +
        strTime
      );
    } else {
      return "-";
    }
  },
};



// WEBPACK FOOTER //
// ./src/helpers/utils.js